import { z } from "zod";

const emptyToUndefined = (value) => {
  if (value === undefined || value === null) return undefined;
  const str = String(value).trim();
  return str.length ? str : undefined;
};

const emptyToNullNumber = (value) => {
  if (value === undefined || value === null) return null;
  const str = String(value).trim();
  if (!str.length) return null;
  const num = Number(str);
  return Number.isFinite(num) ? num : NaN;
};

export const societySchema = z.object({
  society_name: z.string().trim().min(1, "Society name is required"),
  society_type: z.string().trim().min(1, "Property type is required"),
  city: z.string().trim().min(1, "City is required"),
  state: z.preprocess(emptyToUndefined, z.string().trim().min(1).optional()),
  country: z
    .preprocess(emptyToUndefined, z.string().trim().min(1).optional())
    .default("India"),
  contact_number: z
    .string()
    .trim()
    .regex(/^\d{10}$/, "Invalid mobile number"),
  contact_email: z.preprocess(
    emptyToUndefined,
    z.string().trim().email("Invalid email").optional()
  ),
  pincode: z.preprocess(
    emptyToUndefined,
    z.string().trim().regex(/^\d{6}$/, "Invalid pincode").optional()
  ),
  address: z.preprocess(emptyToUndefined, z.string().trim().min(1).optional()),
  google_map_url: z.preprocess(
    emptyToUndefined,
    z
      .string()
      .trim()
      .refine(
        (val) =>
          val.includes("google.") &&
          (val.includes("/maps") || val.includes("maps.google")),
        "Invalid Google Maps URL"
      )
      .optional()
  ),
  latitude: z.preprocess(
    emptyToNullNumber,
    z
      .number({ invalid_type_error: "Latitude must be a number" })
      .min(-90, "Latitude must be between -90 and 90")
      .max(90, "Latitude must be between -90 and 90")
      .nullable()
  ),
  longitude: z.preprocess(
    emptyToNullNumber,
    z
      .number({ invalid_type_error: "Longitude must be a number" })
      .min(-180, "Longitude must be between -180 and 180")
      .max(180, "Longitude must be between -180 and 180")
      .nullable()
  ),
  parent_society_id: z.preprocess(
    emptyToNullNumber,
    z.number().nullable().optional()
  ),
  property_status: z.preprocess(
    emptyToUndefined,
    z.string().trim().optional()
  ).default("operational"),
});

export const zodErrorToFieldErrors = (zodError) => {
  const out = {};
  const flattened = zodError?.flatten?.();
  const fieldErrors = flattened?.fieldErrors || {};
  Object.keys(fieldErrors).forEach((key) => {
    const first = fieldErrors[key]?.[0];
    if (first) out[key] = first;
  });
  return out;
};

